import { orchestrator } from 'satcheljs';
import { getPremiumUser } from '../services/getPremiumUser';
import setPremiumUserState from '../mutators/setPremiumUserState';
import { getPremiumUser as getPremiumUserAction } from '../actions/getPremiumUser';
import store from '../store/store';
import LoadState from '../store/schema/loadState';
import setloadStateOfPremiumUserInfo from '../mutators/setloadStateOfPremiumUserInfo';

export default orchestrator(getPremiumUserAction, async function getPremiumUserAction() {
    if (store.userInfoLoadState == LoadState.Uninitialized) {
        setloadStateOfPremiumUserInfo(LoadState.Loading);
        let response = await getPremiumUser();
        setPremiumUserState(response);
    }
});
